/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Highlight_Settings_WordInputs */

const en_highlight_settings_word = /** @type {(inputs: Highlight_Settings_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Word`)
};

const es_highlight_settings_word = /** @type {(inputs: Highlight_Settings_WordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palabra`)
};

/**
* | output |
* | --- |
* | "Word" |
*
* @param {Highlight_Settings_WordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const highlight_settings_word = /** @type {((inputs?: Highlight_Settings_WordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Highlight_Settings_WordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_highlight_settings_word(inputs)
	return en_highlight_settings_word(inputs)
});